import { render, staticRenderFns } from "./select-prompt.vue?vue&type=template&id=0fa1bb5a&scoped=true&"
import script from "./select-prompt.vue?vue&type=script&lang=js&"
export * from "./select-prompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa1bb5a",
  null
  
)

export default component.exports